import React from 'react';
import { connect } from 'react-redux';
import './login.scss';
import {
  postPhoneNoForOTP,
  setVisibleBlockForLogin,
  postVerifyOTP,
  postEmailLogin,
  setErrorMsg,
  resetLoginScreen,
  forgotPassword,
  resetPassword,
  getUserEmail,
} from 'hb-redux-store/feature/login/login.action';
import USP from '../../components/mweb/USP/USP';
import Input from '../../components/mweb/Input/Input';
import Button from '../../components/common/Button/Button';
import { LOGIN_SCREEN_STATES as STATES } from 'hb-redux-store/util/constantServices';
import {
  getMinutesAndSeconds,
  isValidEmail,
  queryStringToJSON,
} from 'hb-redux-store/util/miscellaneousServices';
import Loader from '../../components/mweb/Skeletons/Loader/Loader';
import { isLoggedInUser } from 'hb-redux-store/util/cookieService';
import { setAppNotification } from 'hb-redux-store/initial.action';
import history from 'hb-redux-store/history';
import Icon from '../../components/mweb/Icon/Icon';

class NormalLoginForm extends React.Component {
  constructor(props) {
    super(props);
    this.isResetPage = props.match.path === '/reset-password/:userUUID/:otp';
    this.isInvitePage = props.match.path === '/invite/:referralCode';
    this.state = {
      phoneNo: '',
      email: '',
      otp: '',
      loggedReason: 'LOGIN',
      password: '',
      isResendDisabled: true,
      resendText: 'Resend otp',
      resendTimer: 0,
      resetMailSent: false,
      resetEmailId: null,
      resendLoginDisableText: 'Try After',
      resendLoginDisableTimer: 0,
      hideSubmitButton: false,
      activateOtpTimer: false,
    };

    if (this.isResetPage) {
      this.userUUID = props.match.params.userUUID;
      this.otp = props.match.params.otp;
      props.setVisibleBlockForLogin({ visibleBlock: STATES.RESET_PASSWORD });
    }
    if (this.isInvitePage) {
      this.referralCode = props.match.params.referralCode;
    }
    if (isLoggedInUser()) {
      let message = 'You are already logged in.';
      let redirectUrl = '/';
      if (this.isInvitePage) {
        if (this.props.launchInfo?.referralActive) {
          message = 'You already register but you can still earn referrals.';
          redirectUrl = '/my/referrals';
        } else {
          message =
            'You already registered. Explore exciting range of products.';
        }
      }
      this.props.setAppNotification(message);
      history.replace(redirectUrl);
    }
  }

  componentDidMount() {
    if (this.isResetPage) {
      this.props.getUserEmail({ userUUID: this.userUUID });
    }
  }

  cancelInterval = null;
  changeView = visibleBlock => {
    this.setState({ resetMailSent: false, hideSubmitButton: false }, () =>
      this.props.setVisibleBlockForLogin({ visibleBlock })
    );
    clearInterval(this.cancelInterval);
  };

  updateState = (values, e) => {
    this.setState({ ...values });
  };

  isFormValid = () => {
    const { visibleBlock, setErrorMsg } = this.props;
    const { phoneNo, email, otp, password } = this.state;
    let errorMessage = null;
    let validForm = true;
    if (visibleBlock === STATES.PHONE_NO) {
      if (!(phoneNo.length === 10 && /d*/.test(phoneNo))) {
        errorMessage = 'Please enter valid phone number.';
        validForm = false;
      }
    }
    if (visibleBlock === STATES.OTP) {
      if (!(phoneNo.length === 10 && /^\d+$/.test(phoneNo))) {
        errorMessage = 'Please enter valid phone number.';
        validForm = false;
      } else if (otp.toString().length !== 4) {
        errorMessage = 'Please enter valid 4 digit OTP.';
        validForm = false;
      }
    }
    if (visibleBlock === STATES.EMAIL) {
      if (!isValidEmail(email)) {
        errorMessage = 'Please enter a valid email Id.';
        validForm = false;
      } else if (password.length < 6) {
        errorMessage = 'Minimum 6 characters password is required';
        validForm = false;
      }
    }
    if (visibleBlock === STATES.FORGOT_PASSWORD) {
      if (!isValidEmail(email)) {
        this.setState({ invalidResetEmail: true });
        validForm = false;
      } else {
        this.setState({ invalidResetEmail: false });
      }
    }
    if (visibleBlock === STATES.RESET_PASSWORD) {
      if (password.length < 6) {
        this.setState({ invalidResetPassword: true });
        validForm = false;
      } else {
        this.setState({ invalidResetPassword: false });
      }
    }
    if (errorMessage) {
      this.props.setAppNotification(errorMessage);
      setErrorMsg(errorMessage);
    }
    return validForm;
  };

  submitForm = e => {
    e && e.preventDefault && e.preventDefault();
    // console.log(e, a, b, c);
    if (this.isFormValid()) {
      this.props.setErrorMsg(null);
      const { phoneNo, email, otp, password, loggedReason } = this.state;
      const { visibleBlock } = this.props;
      const qs = queryStringToJSON(this.props.location.search);
      if (visibleBlock === STATES.PHONE_NO) {
        const postData = { phoneNo };
        if (this.isInvitePage) {
          postData.referralCode = this.referralCode;
        }
        this.props.postPhoneNoForOTP(postData);
      }
      if (visibleBlock === STATES.OTP) {
        this.props.postVerifyOTP({
          phoneNo,
          otp,
          loggedReason,
          redirectUrl: (qs.redirectUrl && `/${qs.redirectUrl}`) || null,
          activeLoginDisabledTimer: !this.props.isLoginDisabled,
        });
      }
      if (visibleBlock === STATES.EMAIL) {
        this.props.postEmailLogin({
          email,
          password,
          loggedReason,
          redirectUrl: (qs.redirectUrl && `/${qs.redirectUrl}`) || null,
        });
      }
      if (visibleBlock === STATES.FORGOT_PASSWORD) {
        if (!this.state.resetMailSent || this.state.resetEmailId !== email) {
          this.setState({ resetMailSent: true, resetEmailId: email }, () => {
            this.props.forgotPassword({ email });
          });
        } else {
          this.props.setAppNotification('Reset password mail is already sent.');
        }
      }
      if (visibleBlock === STATES.RESET_PASSWORD) {
        this.props.resetPassword({
          userUUID: this.userUUID,
          password,
          otp: this.otp,
        });
      }
    }
  };

  activateLoginTmer = prevProps => {
    const thisProps = this.props;
    if (this.cancelInterval) {
      clearInterval(this.cancelInterval);
      this.cancelInterval = null;
      const { minutes, seconds } = getMinutesAndSeconds(
        thisProps?.loginDisabled?.disableTimer
      );
      this.setState({
        resendLoginDisableTimer: prevProps?.loginDisabled?.disableTimer,
        resendText: `Try After ${minutes} minutes ${seconds} seconds`,
        hideSubmitButton: true,
      });
    }
    this.cancelInterval = setInterval(() => {
      let resendLoginDisableTimer = this.state.resendLoginDisableTimer
        ? this.state.resendLoginDisableTimer - 1
        : prevProps?.loginDisabled?.disableTimer;
      if (resendLoginDisableTimer) {
        const { minutes, seconds } = getMinutesAndSeconds(
          resendLoginDisableTimer
        );
        let resendText;
        {
          minutes > 0
            ? (resendText = `Try After ${minutes} minutes ${seconds} seconds`)
            : (resendText = `Try After ${seconds} seconds`);
        }
        this.setState({
          resendLoginDisableTimer,
          resendText,
          isResendDisabled: true,
        });
      } else {
        this.setState(
          {
            resendLoginDisableTimer,
            resendText: 'resend otp',
            isResendDisabled: false,
          },
          () => {
            clearInterval(this.cancelInterval);
          }
        );
      }
    }, 1000);
  };

  componentDidUpdate(prevProps, prevState, snapshot) {
    const thisProps = this.props;
    const { loginDisabled } = thisProps;
    if (
      thisProps.visibleBlock === 'OTP' &&
      loginDisabled?.loginDisable &&
      prevProps?.isLoginDisabled !== thisProps.isLoginDisabled
    ) {
      this.activateLoginTmer(prevProps, prevState);
    }
    if (
      (prevProps.visibleBlock !== thisProps.visibleBlock &&
        thisProps.visibleBlock === 'OTP') ||
      this.state.activateOtpTimer
    ) {
      if (this.cancelInterval) {
        clearInterval(this.cancelInterval);
        this.cancelInterval = null;
        this.setState({
          resendTimer: thisProps.resendWaitTimer,
          resendText: `Resend in ${thisProps.resendWaitTimer} seconds.`,
          activateOtpTimer: false,
        });
      }
      this.cancelInterval = setInterval(() => {
        let resendTimer = this.state.resendTimer
          ? this.state.resendTimer - 1
          : thisProps.resendWaitTimer;
        if (resendTimer) {
          this.setState({
            resendTimer,
            resendText: `Resend in ${resendTimer} seconds.`,
            isResendDisabled: true,
          });
        } else {
          this.setState(
            {
              resendTimer,
              resendText: 'resend otp',
              isResendDisabled: false,
            },
            () => {
              clearInterval(this.cancelInterval);
            }
          );
        }
      }, 1000);
    } else if (
      thisProps.visibleBlock === STATES.RESET_PASSWORD &&
      !this.state.email &&
      thisProps.resetPasswordEmail
    ) {
      this.setState({ email: thisProps.resetPasswordEmail });
    }
  }

  resendOtp = () => {
    if (this.state.isResendDisabled) {
      this.props.setAppNotification(`Please wait before retrying.`);
    } else {
      this.props.postPhoneNoForOTP({ phoneNo: this.state.phoneNo });
      this.setState({ hideSubmitButton: false, activateOtpTimer: true });
    }
  };

  componentWillUnmount() {
    clearInterval(this.cancelInterval);
    this.props.resetLoginScreen();
  }

  render() {
    const {
      phoneNo,
      email,
      otp,
      password,
      isResendDisabled,
      resendText,
      resendTimer,
      hideSubmitButton,
    } = this.state;
    const {
      visibleBlock,
      loginCTA,
      resendWaitTimer,
      errorMsg,
      loading,
      isLoginDisabled,
    } = this.props;
    return (
      <React.Fragment>
        {visibleBlock !== STATES.OTP && <USP scrollable={true} />}
        <div className="login-container">
          <form
            className="login-form"
            name="login-form"
            onSubmit={e => e?.preventDefault && e.preventDefault()}
          >
            {visibleBlock === STATES.PHONE_NO && (
              <React.Fragment>
                <Input
                  type="mobile"
                  prefix="+91"
                  placeholder="Enter your phone number"
                  value={phoneNo}
                  maxLength="10"
                  onChange={this.updateState}
                  name="phoneNo"
                  autoFocus
                />
                <div className="opt-in">
                  <div className="opt-in--message">
                    * By clicking on continue, you agree to our{' '}
                    <a href="/help/tnc#use-of-website" target="_blank">
                      Terms & Conditions
                    </a>
                  </div>
                </div>
                {/* <div
                  className="action-link"
                  onClick={() => this.changeView(STATES.EMAIL)}
                >
                  Or Login via email >
                </div> */}
              </React.Fragment>
            )}
            {visibleBlock === STATES.OTP && (
              <React.Fragment>
                <div className="login-form--otp-sent-text">OTP sent to</div>
                <div className="justify-content--space-between login-form--change-mobile">
                  <div className="login-form--otp-mobile-no">{phoneNo}</div>
                  <div
                    className="action-link"
                    onClick={() => this.changeView(STATES.PHONE_NO)}
                  >
                    change >
                  </div>
                </div>
                <Input
                  type="otp"
                  value={otp}
                  onChange={this.updateState}
                  name="otp"
                  autoFocus
                />
                <div className="login-form--resend-otp">
                  <Button
                    className="button button-ghost full-width large"
                    onClick={this.resendOtp}
                  >
                    {resendText}
                  </Button>
                </div>
              </React.Fragment>
            )}
            {visibleBlock === STATES.EMAIL && (
              <React.Fragment>
                <Input
                  type="email"
                  value={this.state.email}
                  onChange={this.updateState}
                  name="email"
                  placeholder="Enter your Email Id"
                  autoFocus
                />
                <Input
                  type="password"
                  value={this.state.password}
                  onChange={this.updateState}
                  name="password"
                  placeholder="Enter your Password"
                  dataPrivate="lipsum"
                />
                <div>
                  <div
                    className="action-link pull-left"
                    onClick={() => this.changeView(STATES.FORGOT_PASSWORD)}
                  >
                    Forgot password?
                  </div>
                  <div
                    className="action-link pull-right"
                    onClick={() => this.changeView(STATES.PHONE_NO)}
                  >
                    Login via phone number >
                  </div>
                </div>
              </React.Fragment>
            )}
            {visibleBlock === STATES.FORGOT_PASSWORD && (
              <React.Fragment>
                <Input
                  type="email"
                  value={this.state.email}
                  onChange={this.updateState}
                  name="email"
                  placeholder="Enter your Email Id"
                  hasError={this.state.invalidResetEmail}
                  errorMsg="Invalid email."
                  autoFocus
                />
                <div>
                  <div
                    className="action-link pull-right cancel-link"
                    onClick={() => this.changeView(STATES.EMAIL)}
                  >
                    CANCEL
                  </div>
                </div>
              </React.Fragment>
            )}
            {visibleBlock === STATES.RESET_PASSWORD && (
              <React.Fragment>
                {!this.state.email && <Loader />}
                {this.state.email && (
                  <React.Fragment>
                    <Input
                      type="email"
                      value={this.state.email}
                      onChange={this.updateState}
                      name="email"
                      placeholder="Enter your Email Id"
                      disabled
                    />
                    <Input
                      type="password"
                      value={this.state.password}
                      onChange={this.updateState}
                      name="password"
                      placeholder="Enter your Password"
                      hasError={this.state.invalidResetPassword}
                      errorMsg="Minimum 6 characters required"
                      dataPrivate="lipsum"
                    />
                  </React.Fragment>
                )}
              </React.Fragment>
            )}
            {/*{errorMsg && (*/}
            {/*  <div className="login-form--error-message">{errorMsg}</div>*/}
            {/*)}*/}

            {!hideSubmitButton && (
              <div className="bottom-sticky-cta">
                <Button
                  type="submit"
                  className="button button-primary full-width large"
                  onClick={this.submitForm}
                  disabled={loading}
                >
                  {loginCTA}
                </Button>
              </div>
            )}
          </form>
        </div>
      </React.Fragment>
    );
  }
}

const Login = NormalLoginForm;

const mapStateToProps = ({ loginReducer, initialReducer }) => {
  const {
    visibleBlock,
    resendWaitTimer,
    loginCTA,
    errorMsg,
    loginDisabled,
    isLoginDisabled,
  } = loginReducer;
  return {
    visibleBlock,
    resendWaitTimer,
    loginCTA,
    errorMsg,
    loading: loginReducer.loading,
    resetPasswordEmail: loginReducer.resetPasswordEmail,
    launchInfo: initialReducer.launchInfo,
    loginDisabled,
    isLoginDisabled,
  };
};

const mapDispatchToProps = {
  postPhoneNoForOTP,
  setVisibleBlockForLogin,
  postVerifyOTP,
  postEmailLogin,
  setErrorMsg,
  resetLoginScreen,
  forgotPassword,
  resetPassword,
  getUserEmail,
  setAppNotification,
};

export default connect(mapStateToProps, mapDispatchToProps)(Login);
